import { render, staticRenderFns } from "./ReservationCard.vue?vue&type=template&id=5c8ddf19&scoped=true&"
import script from "./ReservationCard.vue?vue&type=script&lang=ts&"
export * from "./ReservationCard.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationCard.vue?vue&type=style&index=0&id=5c8ddf19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8ddf19",
  null
  
)

export default component.exports